import React, { useEffect, useState } from 'react';
import Swal from "sweetalert2"
import Resizer from "react-image-file-resizer"

import '../../styles/pacientesPendientes.css'
import '../../styles/tarjetaContenedor.css'

import { createMedicalPadron,updateMedicalPadron,createCredential, updateUnidadHospitalariaLastNumber } from '../../objects/asociado';
import { saveFile, surgeryroomCollection } from '../../firebase/config';

/**
 * Componentes
 */
//Componente que muestra el encabezado de una sección del site
import EncabezadoSeccion from './encabezadoSeccion';

const AsociadoForm = ({cantidadPacientes,setIsMostrarNuevo,uhList,pacientesList,padronList,userLevel,nomHospital}) => {

    const [nombre,setNombre] = useState("")
    const [apellido,setApellido] = useState("")
    const [nombreHadError, setNombreHadError] = useState(false)
    const [curp,setCurp] = useState("")
    const [curpHadError, setCurpHadError] = useState(false)
    const [especialidad,setEspecialidad] = useState("")
    const [cedula, setCedula] = useState("")
    //const [especialidadHadError, setEspecialidadHadError] = useState(false)
    const [especialidadesArray,setEspecialidadesArray] = useState([])
    const [cedulasEspecialidadesArray,setCedulasEspecialidadesArray] = useState([])
    const [especialidades,setEspecialidades] = useState("")
    const [subespecialidad,setSubEspecialidad] = useState("")
    //const [subEspecialidadHadError, setSubEspecialidadHadError] = useState(false)

    const [copiaTituloProfesional,setCopiaTituloProfesional] = useState("")
    const [mostrarSelectorImagenCopiaTituloProfesional, setMostrarSelectorImagenCopiaTituloProfesional] = useState(false)
    const [urlCopiaTituloProfesional,setUrlCopiaTituloProfesional] = useState("")
    const [fileCopiaTituloProfesional, setFileCopiaTituloProfesional] = useState()
    const [base_copy_professional_title, setBase_copy_professional_title] = useState("")
    //Estado que indica la fecha final del rango deseado
    const [copiaTituloProfesionalDay, setCopiaTituloProfesionalDay] = useState("")
    const [copiaTituloProfesionalExpiraDay, setCopiaTituloProfesionalExpiraDay] = useState("")
    const [tituloProfesionalExpedidoPor, setTituloProfesionalExpedidoPor] = useState("")

    const [copiaCedulaProfesional,setCopiaCedulaProfesional] = useState("")
    const [mostrarSelectorImagenCopiaCedulaProfesional, setMostrarSelectorImagenCopiaCedulaProfesional] = useState(false)
    const [urlCopiaCedulaProfesional,setUrlCopiaCedulaProfesional] = useState("")
    const [fileCopiaCedulaProfesional,setFileCopiaCedulaProfesional] = useState("")
    const [base_copy_professional_license, setBase_copy_professional_license] = useState("")
    const [copiaCedulaProfesionalDay, setCopiaCedulaProfesionalDay] = useState("")
    const [copiaCedulaProfesionalExpiraDay, setCopiaCedulaProfesionalExpiraDay] = useState("")
    const [CedulaProfesionalExpedidoPor, setCedulaProfesionalExpedidoPor] = useState("")

    const [copiaCedulaEspecialidad,setCopiaCedulaEspecialidad] = useState("")
    const [mostrarSelectorImagenCopiaCedulaEspecialidad, setMostrarSelectorImagenCopiaCedulaEspecialidad] = useState(false)
    const [urlCopiaCedulaEspecialidad,setUrlCopiaCedulaEspecialidad] = useState("")
    const [fileCopiaCedulaEspecialidad,setFileCopiaCedulaEspecialidad] = useState("")
    const [base_copy_specialty_certificate, setBase_copy_specialty_certificate] = useState("")
    const [copiaCedulaEspecialidadDay, setCopiaCedulaEspecialidadDay] = useState("")
    const [copiaCedulaEspecialidadExpiraDay, setCopiaCedulaEspecialidadExpiraDay] = useState("")
    const [CedulaEspecialidadExpedidoPor, setCedulaEspecialidadExpedidoPor] = useState("")

    const [copiaTituloEspecialidad,setCopiaTituloEspecialidad] = useState("")
    const [mostrarSelectorImagenCopiaTituloEspecialidad, setMostrarSelectorImagenCopiaTituloEspecialidad] = useState(false)
    const [urlCopiaTituloEspecialidad,setUrlCopiaTituloEspecialidad] = useState("")
    const [fileCopiaTituloEspecialidad,setFileCopiaTituloEspecialidad] = useState("")
    const [copiaTituloEspecialidadDay, setCopiaTituloEspecialidadDay] = useState("")
    const [copiaTituloEspecialidadExpiraDay, setCopiaTituloEspecialidadExpiraDay] = useState("")
    const [copiaTituloEspecialidadExpedidoPor, setCopiaTituloEspecialidadExpedidoPor] = useState("")

    const [copiaTituloSubEspecialidad,setCopiaTituloSubEspecialidad] = useState("")
    const [mostrarSelectorImagenCopiaTituloSubEspecialidad, setMostrarSelectorImagenCopiaTituloSubEspecialidad] = useState(false)
    const [urlCopiaTituloSubEspecialidad,setUrlCopiaTituloSubEspecialidad] = useState("")
    const [fileCopiaTituloSubEspecialidad,setFileCopiaTituloSubEspecialidad] = useState("")
    const [base_copy_specialty_title, setBase_copy_specialty_title] = useState("")
    const [base_copy_subspecialty_professional_certificate,setBase_copy_subspecialty_professional_certificate] = useState("")
    const [copiaTituloSubEspecialidadDay, setCopiaTituloSubEspecialidadDay] = useState("")
    const [copiaTituloSubEspecialidadExpiraDay, setCopiaTituloSubEspecialidadExpiraDay] = useState("")
    const [copiaTituloSubEspecialidadExpedidoPor, setCopiaTituloSubEspecialidadExpedidoPor] = useState("")

    const [cv,setCv] = useState("")
    const [mostrarSelectorImagenCv, setMostrarSelectorImagenCv] = useState(false)
    const [urlCv,setUrlCv] = useState("")
    const [fileCv,setFileCv] = useState("")
    const [baseCv, setBaseCv] = useState("")

    const [fotografia,setFotografia] = useState("")
    const [mostrarSelectorImagenFotografia, setMostrarSelectorImagenFotografia] = useState(false)
    const [urlFotografia,setUrlFotografia] = useState("")
    const [fileFotografia,setFileFotografia] = useState("")
    const [baseFotografia, setBaseFotografia] = useState("")

    const [ine,setIne] = useState("")
    const [mostrarSelectorImagenIne, setMostrarSelectorImagenIne] = useState(false)
    const [urlIne,setUrlIne] = useState("")
    const [fileIne,setFileIne] = useState("")
    const [baseIne,setBaseIne] = useState("")

    const [rfc,setRfc] = useState("")
    const [mostrarSelectorImagenRfc, setMostrarSelectorImagenRfc] = useState(false)
    const [urlRfc,setUrlRfc] = useState("")
    const [fileRfc,setFileRfc] = useState("")
    const [baseRfc,setBaseRfc] = useState("")

    const [avisoFuncionamiento,setAvisoFuncionamiento] = useState("")
    const [mostrarSelectorImagenAvisoFuncionamiento, setMostrarSelectorImagenAvisoFuncionamiento] = useState(false)
    const [urlAvisoFuncionamiento,setUrlAvisoFuncionamiento] = useState("")
    const [fileAvisoFuncionamiento,setFileAvisoFuncionamiento] = useState("")
    const [avisoFuncionamientoDay, setAvisoFuncionamientoDay] = useState("")
    const [avisoFuncionamientoExpiraDay, setAvisoFuncionamientoExpiraDay] = useState("")
    const [avisoFuncionamientoExpedidoPor, setAvisoFuncionamientoExpedidoPor] = useState("")

    const [registroEstatalProfesionales,setRegistroEstatalProfesionales] = useState("")
    const [mostrarSelectorImagenRegistroEstatalProfesionales, setMostrarSelectorImagenRegistroEstatalProfesionales] = useState(false)
    const [urlRegistroEstatalProfesionales,setUrlRegistroEstatalProfesionales] = useState("")
    const [fileRegistroEstatalProfesionales,setFileRegistroEstatalProfesionales] = useState("")
    const [registroEstatalProfesionalesDay, setRegistroEstatalProfesionalesDay] = useState("")
    const [registroEstatalProfesionalesExpiraDay, setRegistroEstatalProfesionalesExpiraDay] = useState("")
    const [registroEstatalProfesionalesExpedidoPor, setRegistroEstatalProfesionalesExpedidoPor] = useState("")

    const [cedulaSubEspecialidad,setCedulaSubEspecialidad] = useState("")
    const [mostrarSelectorImagenCedulaSubEspecialidad, setMostrarSelectorImagenCedulaSubEspecialidad] = useState(false)
    const [urlCedulaSubEspecialidad,setUrlCedulaSubEspecialidad] = useState("")
    const [fileCedulaSubEspecialidad,setFileCedulaSubEspecialidad] = useState("")

    const [certificacionConsejoEspecialidad,setCertificacionConsejoEspecialidad] = useState("")
    const [mostrarSelectorImagenCertificacionConsejoEspecialidad, setMostrarSelectorImagenCertificacionConsejoEspecialidad] = useState(false)
    const [urlCertificacionConsejoEspecialidad,setUrlCertificacionConsejoEspecialidad] = useState("")
    const [fileCertificacionConsejoEspecialidad,setFileCertificacionConsejoEspecialidad] = useState("")
    const [certificacionConsejoEspecialidadDay, setCertificacionConsejoEspecialidadDay] = useState("")
    const [certificacionConsejoEspecialidadExpiraDay, setCertificacionConsejoEspecialidadExpiraDay] = useState("")
    const [certificacionConsejoEspecialidadExpedidoPor, setCertificacionConsejoEspecialidadExpedidoPor] = useState("")

    const [constanciaUnoName,setConstanciaUnoName] = useState("")
    const [constanciaUno,setConstanciaUno] = useState("")
    const [mostrarSelectorImagenConstanciaUno, setMostrarSelectorImagenConstanciaUno] = useState(false)
    const [urlConstanciaUno,setUrlConstanciaUno] = useState("")
    const [fileConstanciaUno,setFileConstanciaUno] = useState("")

    const [constanciaDosName,setConstanciaDosName] = useState("")
    const [constanciaDos,setConstanciaDos] = useState("")
    const [mostrarSelectorImagenConstanciaDos, setMostrarSelectorImagenConstanciaDos] = useState(false)
    const [urlConstanciaDos,setUrlConstanciaDos] = useState("")
    const [fileConstanciaDos,setFileConstanciaDos] = useState("")

    const [constanciaTresName,setConstanciaTresName] = useState("")
    const [constanciaTres,setConstanciaTres] = useState("")
    const [mostrarSelectorImagenConstanciaTres, setMostrarSelectorImagenConstanciaTres] = useState(false)
    const [urlConstanciaTres,setUrlConstanciaTres] = useState("")
    const [fileConstanciaTres,setFileConstanciaTres] = useState("")

    const [constanciaCuatroName,setConstanciaCuatroName] = useState("")
    const [constanciaCuatro,setConstanciaCuatro] = useState("")
    const [mostrarSelectorImagenConstanciaCuatro, setMostrarSelectorImagenConstanciaCuatro] = useState(false)
    const [urlConstanciaCuatro,setUrlConstanciaCuatro] = useState("")
    const [fileConstanciaCuatro,setFileConstanciaCuatro] = useState("")

    const [constanciaCincoName,setConstanciaCincoName] = useState("")
    const [constanciaCinco,setConstanciaCinco] = useState("")
    const [mostrarSelectorImagenConstanciaCinco, setMostrarSelectorImagenConstanciaCinco] = useState(false)
    const [urlConstanciaCinco,setUrlConstanciaCinco] = useState("")
    const [fileConstanciaCinco,setFileConstanciaCinco] = useState("")

    const [uhSelected,setUhSelectd] = useState("")

    const [identificadorUnico, setIdentificadorUnico] = useState("")

    const [sexo,setSexo] = useState(1)
    const [base_copy_subspecial_title,setBase_copy_subspecial_title] = useState("")
    const [copiaTituloSubespecialidadDay, setCopiaTituloSubespecialidadDay] = useState("")
    const [copiaTituloSubespecialidadExpiraDay, setCopiaTituloSubespecialidadExpiraDay] = useState("")
    const [copiaTituloSubespecialidadExpedidoPor, setCopiaTituloSubespecialidadExpedidoPor] = useState("")
    const [base_copy_specialty_board_certification, setBase_copy_specialty_board_certification] = useState("")
    const [base_copy_of_office_operating_notice, setbBase_copy_of_office_operating_notice] = useState("")
    const [base_copy_state_registry_of_professions, setBase_copy_state_registry_of_professions] = useState("")
    //const [base_contancies_one, setBase_contancies_one] = useState("")

    const [isAdmin,setIsAdmin] = useState(false)
    //Estado que indica la fecha del dia actual
    const [today, setToday] = useState(new Date())

    useEffect(()=>{
        let five = new Date().getFullYear();
        let four = five -1;
        let three = four -1;
        let two = three - 1
        let one = two - 1
        setConstanciaUnoName(one)
        setConstanciaDosName(two)
        setConstanciaTresName(three)
        setConstanciaCuatroName(four)
        setConstanciaCincoName(five)
        setNombreHadError(false)
        setCurpHadError(false)
        setSexo(1)
        setToday(new Date())
    },[])

    useEffect(()=>{
        if(uhList.length > 0){
            setUhSelectd(uhList[0].hospital)
        }
    },[uhList])

    useEffect(()=>{
        if(userLevel === 'credencializacion'){
            setUhSelectd(nomHospital)
            setIsAdmin(false)
        }
        else{
            setIsAdmin(true)
        }
    },[userLevel,nomHospital])

    useEffect(()=>{
        if(uhSelected){
            for(let i=0;i<uhList.length;i++){
                if(uhList[i].hospital === uhSelected){
                    let nemonico = uhList[i].mnemonicos
                    let consecutivo = parseInt(uhList[i].num_asociado)
                    consecutivo = consecutivo + 1
                    setIdentificadorUnico(nemonico + "-" + consecutivo.toString().padStart(5, '0'))
                }
            }
        }
    },[uhSelected,uhList])

    useEffect(()=>{
        if(identificadorUnico){
            setUrlCopiaTituloProfesional(surgeryroomCollection+"/docs/"+ uhSelected + "/" + identificadorUnico + "/copy_professional_title")
            setUrlCopiaCedulaProfesional(surgeryroomCollection+"/docs/"+ uhSelected + "/" + identificadorUnico + "/copy_professional_license")
            setUrlCopiaCedulaEspecialidad(surgeryroomCollection+"/docs/"+ uhSelected + "/" + identificadorUnico + "/copy_specialty_certificate")
            setUrlCopiaTituloEspecialidad(surgeryroomCollection+"/docs/"+ uhSelected + "/" + identificadorUnico + "/copy_specialty_title")
            setUrlCopiaTituloSubEspecialidad(surgeryroomCollection+"/docs/"+ uhSelected + "/" + identificadorUnico + "/copy_subspecial_title")
            setUrlCv(surgeryroomCollection+"/docs/"+ uhSelected + "/" + identificadorUnico + "/curriculum_vitae")
            setUrlFotografia(surgeryroomCollection+"/docs/"+ uhSelected + "/" + identificadorUnico + "/photo")
            setUrlIne(surgeryroomCollection+"/docs/"+ uhSelected + "/" + identificadorUnico + "/ine")
            setUrlRfc(surgeryroomCollection+"/docs/"+ uhSelected + "/" + identificadorUnico + "/rfc")
            setUrlAvisoFuncionamiento(surgeryroomCollection+"/docs/"+ uhSelected + "/" + identificadorUnico + "/copy_of_office_operating_notice")
            setUrlRegistroEstatalProfesionales(surgeryroomCollection+"/docs/"+ uhSelected + "/" + identificadorUnico + "/copy_state_registry_of_professions")
            setUrlCedulaSubEspecialidad(surgeryroomCollection+"/docs/"+ uhSelected + "/" + identificadorUnico + "/copy_subspecialty_professional_certificate")
            setUrlCertificacionConsejoEspecialidad(surgeryroomCollection+"/docs/"+ uhSelected + "/" + identificadorUnico + "/copy_specialty_board_certification")
            setUrlConstanciaUno(surgeryroomCollection+"/docs/"+ uhSelected + "/" + identificadorUnico + "/contancies/" + constanciaUnoName)
            setUrlConstanciaDos(surgeryroomCollection+"/docs/"+ uhSelected + "/" + identificadorUnico + "/contancies/" + constanciaDosName)
            setUrlConstanciaTres(surgeryroomCollection+"/docs/"+ uhSelected + "/" + identificadorUnico + "/contancies/" + constanciaTresName)
            setUrlConstanciaCuatro(surgeryroomCollection+"/docs/"+ uhSelected + "/" + identificadorUnico + "/contancies/" + constanciaCuatroName)
            setUrlConstanciaCinco(surgeryroomCollection+"/docs/"+ uhSelected + "/" + identificadorUnico + "/contancies/" + constanciaCincoName)
        }
    },[identificadorUnico,uhSelected,constanciaUnoName,constanciaDosName,constanciaTresName,constanciaCuatroName,constanciaCincoName])

    const handleAgregar = () => (event) => {
        event.preventDefault()
        setIsMostrarNuevo(false)
    }

    const onChangeNombre = (cedula) => {
        setNombre(cedula.target.value.toString())
    };

    const onChangeApellido = (cedula) => {
        setApellido(cedula.target.value.toString())
    };

    const onChangeCurp = (cedula) => {
        setCurp(cedula.target.value.toString().toUpperCase())
    };

    const onChangeEspecialidad = (cedula) => {
        setEspecialidad(cedula.target.value.toString())
    };

    const onChangeCedulaEspecialidad = (cedula) => {
        setCedula(cedula.target.value.toString())
    };

    const onChangeSubEspecialidad = (cedula) => {
        setSubEspecialidad(cedula.target.value.toString())
    };

    const onChangeCopiaTituloProfesional = (sexo) => {
        setCopiaTituloProfesional(sexo.target.value)
    };

    useEffect(()=>{
        if(copiaTituloProfesional === '1'){
            setMostrarSelectorImagenCopiaTituloProfesional(true)
        }
        else{
            setMostrarSelectorImagenCopiaTituloProfesional(false)
        }
    },[copiaTituloProfesional])


    const onChangeCopiaCedulaProfesional = (sexo) => {
        setCopiaCedulaProfesional(sexo.target.value)
    };

    useEffect(()=>{
        if(copiaCedulaProfesional === '1'){
            setMostrarSelectorImagenCopiaCedulaProfesional(true)
        }
        else{
            setMostrarSelectorImagenCopiaCedulaProfesional(false)
        }
    },[copiaCedulaProfesional])

    const onChangeCopiaCedulaEspecialidad = (sexo) => {
        setCopiaCedulaEspecialidad(sexo.target.value)
    };

    useEffect(()=>{
        if(copiaCedulaEspecialidad === '1'){
            setMostrarSelectorImagenCopiaCedulaEspecialidad(true)
        }
        else{
            setMostrarSelectorImagenCopiaCedulaEspecialidad(false)
        }
    },[copiaCedulaEspecialidad])

    const onChangeCopiaTituloEspecialidad = (sexo) => {
        setCopiaTituloEspecialidad(sexo.target.value)
    };

    useEffect(()=>{
        if(copiaTituloEspecialidad === '1'){
            setMostrarSelectorImagenCopiaTituloEspecialidad(true)
        }
        else{
            setMostrarSelectorImagenCopiaTituloEspecialidad(false)
        }
    },[copiaTituloEspecialidad])

    const onChangeCopiaTituloSubEspecialidad = (sexo) => {
        setCopiaTituloSubEspecialidad(sexo.target.value)
    };

    useEffect(()=>{
        if(copiaTituloSubEspecialidad === '1'){
            setMostrarSelectorImagenCopiaTituloSubEspecialidad(true)
        }
        else{
            setMostrarSelectorImagenCopiaTituloSubEspecialidad(false)
        }
    },[copiaTituloSubEspecialidad])

    const onChangeCv = (sexo) => {
        setCv(sexo.target.value)
    };

    useEffect(()=>{
        if(cv === '1'){
            setMostrarSelectorImagenCv(true)
        }
        else{
            setMostrarSelectorImagenCv(false)
        }
    },[cv])

    const onChangeFotografia = (sexo) => {
        setFotografia(sexo.target.value)
    };

    // const onChangeSexo = (sexo) => {
    //     console.log(sexo.target.value)
    //     setSexo(sexo.target.value)
    // };


    useEffect(()=>{
        if(fotografia === '1'){
            setMostrarSelectorImagenFotografia(true)
        }
        else{
            setMostrarSelectorImagenFotografia(false)
        }
    },[fotografia])

    const onChangeIne = (sexo) => {
        setIne(sexo.target.value)
    };

    useEffect(()=>{
        if(ine === '1'){
            setMostrarSelectorImagenIne(true)
        }
        else{
            setMostrarSelectorImagenIne(false)
        }
    },[ine])

    const onChangeRfc = (sexo) => {
        setRfc(sexo.target.value)
    };

    useEffect(()=>{
        if(rfc === '1'){
            setMostrarSelectorImagenRfc(true)
        }
        else{
            setMostrarSelectorImagenRfc(false)
        }
    },[rfc])

    const onChangeAvisoFuncionamiento = (sexo) => {
        setAvisoFuncionamiento(sexo.target.value)
    };

    useEffect(()=>{
        if(avisoFuncionamiento === '1'){
            setMostrarSelectorImagenAvisoFuncionamiento(true)
        }
        else{
            setMostrarSelectorImagenAvisoFuncionamiento(false)
        }
    },[avisoFuncionamiento])

    const onChangeRegistroEstatalProfesionales = (sexo) => {
        setRegistroEstatalProfesionales(sexo.target.value)
    };

    useEffect(()=>{
        if(registroEstatalProfesionales === '1'){
            setMostrarSelectorImagenRegistroEstatalProfesionales(true)
        }
        else{
            setMostrarSelectorImagenRegistroEstatalProfesionales(false)
        }
    },[registroEstatalProfesionales])

    const onChangeCedulaSubEspecialidad = (sexo) => {
        setCedulaSubEspecialidad(sexo.target.value)
    };

    useEffect(()=>{
        if(cedulaSubEspecialidad === '1'){
            setMostrarSelectorImagenCedulaSubEspecialidad(true)
        }
        else{
            setMostrarSelectorImagenCedulaSubEspecialidad(false)
        }
    },[cedulaSubEspecialidad])

    const onChangeCertificadoConsejoEspecialidad = (sexo) => {
        setCertificacionConsejoEspecialidad(sexo.target.value)
    };

    useEffect(()=>{
        if(certificacionConsejoEspecialidad === '1'){
            setMostrarSelectorImagenCertificacionConsejoEspecialidad(true)
        }
        else{
            setMostrarSelectorImagenCertificacionConsejoEspecialidad(false)
        }
    },[certificacionConsejoEspecialidad])

    const onChangeConstanciaUno = (sexo) => {
        setConstanciaUno(sexo.target.value)
    };

    useEffect(()=>{
        if(constanciaUno === '1'){
            setMostrarSelectorImagenConstanciaUno(true)
        }
        else{
            setMostrarSelectorImagenConstanciaUno(false)
        }
    },[constanciaUno])

    const onChangeConstanciaDos = (sexo) => {
        setConstanciaDos(sexo.target.value)
    };

    useEffect(()=>{
        if(constanciaDos === '1'){
            setMostrarSelectorImagenConstanciaDos(true)
        }
        else{
            setMostrarSelectorImagenConstanciaDos(false)
        }
    },[constanciaDos])

    const onChangeConstanciaTres = (sexo) => {
        setConstanciaTres(sexo.target.value)
    };

    useEffect(()=>{
        if(constanciaTres === '1'){
            setMostrarSelectorImagenConstanciaTres(true)
        }
        else{
            setMostrarSelectorImagenConstanciaTres(false)
        }
    },[constanciaTres])

    const onChangeConstanciaCuatro = (sexo) => {
        setConstanciaCuatro(sexo.target.value)
    };

    useEffect(()=>{
        if(constanciaCuatro === '1'){
            setMostrarSelectorImagenConstanciaCuatro(true)
        }
        else{
            setMostrarSelectorImagenConstanciaCuatro(false)
        }
    },[constanciaCuatro])

    const onChangeConstanciaCinco = (sexo) => {
        setConstanciaCinco(sexo.target.value)
    };

    useEffect(()=>{
        if(constanciaCinco === '1'){
            setMostrarSelectorImagenConstanciaCinco(true)
        }
        else{
            setMostrarSelectorImagenConstanciaCinco(false)
        }
    },[constanciaCinco])


    const handleChange = (e) => {
        setUhSelectd(e.target.value)
      };

      const handleAgregarEspecialidadClick = () => (event) => {
        event.preventDefault()
        if(especialidad && cedula){
          setEspecialidadesArray([...especialidadesArray,{especialidad}])
          setEspecialidad('')
          setCedulasEspecialidadesArray([...cedulasEspecialidadesArray,{cedula}])
          setCedula('')
        }
    }

    useEffect(()=>{
        if(especialidadesArray.length >0){
            let mostrarEspecialidades = ''
            for(let i=0;i<especialidadesArray.length;i++){
                mostrarEspecialidades += especialidadesArray[i].especialidad + ' '
            }
            setEspecialidades(mostrarEspecialidades)
        }
        else{
            setEspecialidades('')
        }
    },[especialidadesArray])


    const handleGuardar = () => (event) => {
        event.preventDefault()

        let array = []
        if(especialidadesArray.length >0){
            for(let i=0;i<especialidadesArray.length;i++){
                array.push(especialidadesArray[i].especialidad)
            }
        }
        else{
            array.push(especialidad)
        }

        let cedula_array = []
        if(cedulasEspecialidadesArray.length >0){
            for(let i=0;i<cedulasEspecialidadesArray.length;i++){
                cedula_array.push(cedulasEspecialidadesArray[i].cedula)
            }
        }
        else{
            cedula_array.push(cedula)
        }

        let constancias = [{
            "year" : constanciaUnoName,
            "sendig" : mostrarSelectorImagenConstanciaUno,
            "url" : urlConstanciaUno
        },{
            "year" : constanciaDosName,
            "sendig" : mostrarSelectorImagenConstanciaDos,
            "url" : urlConstanciaDos
        },{
            "year" : constanciaTresName,
            "sendig" : mostrarSelectorImagenConstanciaTres,
            "url" : urlConstanciaTres
        },{
            "year" : constanciaCuatroName,
            "sendig" : mostrarSelectorImagenConstanciaCuatro,
            "url" : urlConstanciaCuatro
        },{
            "year" : constanciaCincoName,
            "sendig" : mostrarSelectorImagenConstanciaCinco,
            "url" : urlConstanciaCinco
        }]


        let credentialObject = {
            "copy_specialty_certificate":mostrarSelectorImagenCopiaCedulaEspecialidad,
            "copy_professional_license":mostrarSelectorImagenCopiaCedulaProfesional,
            "name":nombre,
            "copy_subspecial_title":mostrarSelectorImagenCopiaTituloSubEspecialidad,
            "curriculum_vitae":mostrarSelectorImagenCv,
            "copy_professional_title":mostrarSelectorImagenCopiaTituloProfesional,
            "status":"Vigente (expediente completo)",
            "subspecialty":subespecialidad,
            "copy_specialty_title":mostrarSelectorImagenCopiaTituloEspecialidad,
            "active":true,
            "specialty":array[0],
            "curp":curp,
            "specialty_array":array,
            "hospital" : uhSelected,
            "url_copy_professional_title":urlCopiaTituloProfesional,
            "url_copy_professional_license":urlCopiaCedulaProfesional,
            "url_copy_specialty_certificate":urlCopiaCedulaEspecialidad,
            "url_copy_specialty_title":urlCopiaTituloEspecialidad,
            "url_copy_subspecial_title":urlCopiaTituloSubEspecialidad,
            "url_curriculum_vitae":urlCv,
            "identificador" : identificadorUnico,
            "photo" : mostrarSelectorImagenFotografia,
            "url_photo" : urlFotografia,
            "ine" : mostrarSelectorImagenIne,
            "url_ine" : urlIne,
            "rfc" : rfc,
            "url_rfc" : urlRfc,
            "copy_of_office_operating_notice" : mostrarSelectorImagenAvisoFuncionamiento,
            "url_copy_of_office_operating_notice" : urlAvisoFuncionamiento,
            "copy_state_registry_of_professions" : mostrarSelectorImagenRegistroEstatalProfesionales,
            "url_copy_state_registry_of_professions" : urlRegistroEstatalProfesionales,
            "copy_subspecialty_professional_certificate" : mostrarSelectorImagenCedulaSubEspecialidad,
            "url_copy_subspecialty_professional_certificate" : urlCedulaSubEspecialidad,
            "copy_specialty_board_certification" : mostrarSelectorImagenCertificacionConsejoEspecialidad,
            "url_copy_specialty_board_certification" : urlCertificacionConsejoEspecialidad,
            "contancies" : constancias,
            "cedula_array" : cedula_array,
            "lastname" : apellido,
            "basefotografia" : baseFotografia,
            "gender" : sexo ,
            "baseine" : baseIne,
            "baserfc" : baseRfc,
            "baseCv" : baseCv,
            "base_copy_professional_title" : base_copy_professional_title,
            "base_copy_professional_license" : base_copy_professional_license,
            "base_copy_specialty_certificate" : base_copy_specialty_certificate,
            "base_copy_specialty_title" : base_copy_specialty_title,
            "base_copy_subspecialty_professional_certificate" : base_copy_subspecialty_professional_certificate,
            "base_copy_subspecial_title" : base_copy_subspecial_title,
            "base_copy_specialty_board_certification" : base_copy_specialty_board_certification,
            "base_copy_of_office_operating_notice" : base_copy_of_office_operating_notice,
            "base_copy_state_registry_of_professions" : base_copy_state_registry_of_professions,
            "base_contancies_one" : "",
            "copiaTituloProfesionalDay" : copiaTituloProfesionalDay,
            "copiaTituloProfesionalExpiraDay" : copiaTituloProfesionalExpiraDay,
            "tituloProfesionalExpedidoPor" : tituloProfesionalExpedidoPor,
            "copiaCedulaProfesionalDay" : copiaCedulaProfesionalDay,
            "copiaCedulaProfesionalExpiraDay" : copiaCedulaProfesionalExpiraDay,
            "CedulaProfesionalExpedidoPor" : CedulaProfesionalExpedidoPor,
            "copiaCedulaEspecialidadDay" : copiaCedulaEspecialidadDay,
            "copiaCedulaEspecialidadExpiraDay" : copiaCedulaEspecialidadExpiraDay,
            "CedulaEspecialidadExpedidoPor" : CedulaEspecialidadExpedidoPor,
            "copiaTituloEspecialidadDay" : copiaTituloEspecialidadDay,
            "copiaTituloEspecialidadExpiraDay" : copiaTituloEspecialidadExpiraDay,
            "copiaTituloEspecialidadExpedidoPor" : copiaTituloEspecialidadExpedidoPor,
            "copiaTituloSubEspecialidadDay" : copiaTituloSubEspecialidadDay,
            "copiaTituloSubEspecialidadExpiraDay" : copiaTituloSubEspecialidadExpiraDay,
            "copiaTituloSubEspecialidadExpedidoPor" : copiaTituloSubEspecialidadExpedidoPor,
            "copiaTituloSubespecialidadDay" : copiaTituloSubespecialidadDay,
            "copiaTituloSubespecialidadExpiraDay" : copiaTituloSubespecialidadExpiraDay,
            "copiaTituloSubespecialidadExpedidoPor" : copiaTituloSubespecialidadExpedidoPor,
            "certificacionConsejoEspecialidadDay" : certificacionConsejoEspecialidadDay,
            "certificacionConsejoEspecialidadExpiraDay" : certificacionConsejoEspecialidadExpiraDay,
            "certificacionConsejoEspecialidadExpedidoPor" : certificacionConsejoEspecialidadExpedidoPor,
            "avisoFuncionamientoDay" : avisoFuncionamientoDay,
            "avisoFuncionamientoExpiraDay" : avisoFuncionamientoExpiraDay,
            "avisoFuncionamientoExpedidoPor" : avisoFuncionamientoExpedidoPor,
            "registroEstatalProfesionalesDay" : registroEstatalProfesionalesDay,
            "registroEstatalProfesionalesExpiraDay" : registroEstatalProfesionalesExpiraDay,
            "registroEstatalProfesionalesExpedidoPor" : registroEstatalProfesionalesExpedidoPor
        }

        let isNewCredential = true
        for(let i =0;i<pacientesList.length;i++){
            if(pacientesList[i].curp.toUpperCase()=== curp.toUpperCase()){
                isNewCredential = false
            }
        }

        if(isNewCredential){
            console.log(credentialObject)
            solicitarRegistroCredencial(curp.toUpperCase())
        }
        else{
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Ya existe un asociado con el CURP proporcionado',
            })
        }

        async function solicitarRegistroCredencial(curp){
            let isNewMedicalPadron = true
            let medicalPadronId = 0
            for(let i=0;i<padronList.length;i++){
                if(curp.toUpperCase() === padronList[i].curp.toUpperCase()){
                    isNewMedicalPadron = false
                    medicalPadronId = padronList[i].id
                }
            }

            if(isNewMedicalPadron){
                solicitarRegistroPadron()
                async function solicitarRegistroPadron(){
                    createMedicalPadron(credentialObject)
                }
            }
            else{
                solicitarActualizacionPadron()
                async function solicitarActualizacionPadron(){
                    updateMedicalPadron(medicalPadronId,credentialObject)
                }
                
            }

            const response = await createCredential(credentialObject)

            if(fileCopiaTituloProfesional){
                saveFile(fileCopiaTituloProfesional,urlCopiaTituloProfesional)
            }
            
            if(fileCopiaCedulaProfesional){
                saveFile(fileCopiaCedulaProfesional,urlCopiaCedulaProfesional)
            }
            
            if(fileCopiaCedulaEspecialidad){
                saveFile(fileCopiaCedulaEspecialidad,urlCopiaCedulaEspecialidad)
            }
            
            if(fileCopiaTituloEspecialidad){
                saveFile(fileCopiaTituloEspecialidad,urlCopiaTituloEspecialidad)
            }
            
            if(fileCopiaTituloSubEspecialidad){
                saveFile(fileCopiaTituloSubEspecialidad,urlCopiaTituloSubEspecialidad)
            }
            
            if(fileCv){
                saveFile(fileCv,urlCv)
            }

            if(fileFotografia){
                saveFile(fileFotografia,urlFotografia)
            }

            if(fileIne){
                saveFile(fileIne,urlIne)
            }
            
            if(fileRfc){
                saveFile(fileRfc,urlRfc)
            }

            if(fileAvisoFuncionamiento){
                saveFile(fileAvisoFuncionamiento,urlAvisoFuncionamiento)
            }

            if(fileRegistroEstatalProfesionales){
                saveFile(fileRegistroEstatalProfesionales, urlRegistroEstatalProfesionales)
            }

            if(fileCedulaSubEspecialidad){
                saveFile(fileCedulaSubEspecialidad,urlCedulaSubEspecialidad)
            }

            if(fileCertificacionConsejoEspecialidad){
                saveFile(fileCertificacionConsejoEspecialidad,urlCertificacionConsejoEspecialidad)
            }

            if(fileConstanciaUno){
                saveFile(fileConstanciaUno, urlConstanciaUno)
            }

            if(fileConstanciaDos){
                saveFile(fileConstanciaDos, urlConstanciaDos)
            }

            if(fileConstanciaTres){
                saveFile(fileConstanciaTres, urlConstanciaTres)
            }

            if(fileConstanciaCuatro){
                saveFile(fileConstanciaCuatro,urlConstanciaCuatro)
            }

            if(fileConstanciaCinco){
                saveFile(fileConstanciaCinco,urlConstanciaCinco)
            }

            if(response === "success"){//Actualización de usuario exitosa
                for(let i=0;i<uhList.length;i++){
                    if(uhList[i].hospital === uhSelected){
                        let consecutivo = parseInt(uhList[i].num_asociado)
                        consecutivo = consecutivo + 1
                        updateUnidadHospitalariaLastNumber(uhList[i].identificador,consecutivo)
                    }
                }
                setIsMostrarNuevo(false)

            }
            else{//Error en la actualización de usuario
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response,
                })
            }
        }
    }

    const resizeFile = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      270,
      270,
      "PNG",
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "base64"
    );
  });

  const onCopitaTitutloProfesionalExpedidoChange = e => {
    setCopiaTituloProfesionalDay(e.target.value)
  };

  const onCopitaTitutloProfesionalExpiraChange = e => {
    setCopiaTituloProfesionalExpiraDay(e.target.value)
  };

  const onChangeTituloProfesionalExpedidoPor = (cedula) => {
    setTituloProfesionalExpedidoPor(cedula.target.value.toString())
};

const onCopiaCedulaProfesionalExpedidoChange = e => {
    setCopiaCedulaProfesionalDay(e.target.value)
  };

  const onCopiaCedulaProfesionalExpiraChange = e => {
    setCopiaCedulaProfesionalExpiraDay(e.target.value)
  };

  const onChangeCedulaProfesionalExpedidoPor = (cedula) => {
    setCedulaProfesionalExpedidoPor(cedula.target.value.toString())
};

const onCopiaCedulaEspecialidadExpedidoChange = e => {
    setCopiaCedulaEspecialidadDay(e.target.value)
  };

  const onCopiaCedulaEspecialidadExpiraChange = e => {
    setCopiaCedulaEspecialidadExpiraDay(e.target.value)
  };

  const onChangeCedulaEspecialidadExpedidoPor = (cedula) => {
    setCedulaEspecialidadExpedidoPor(cedula.target.value.toString())
};

const onCopiaTituloEspecialidadExpedidoChange = e => {
    setCopiaTituloEspecialidadDay(e.target.value)
  };

  const onCopiaTituloEspecialidadExpiraChange = e => {
    setCopiaTituloEspecialidadExpiraDay(e.target.value)
  };

  const onChangeCopiaTituloEspecialidadExpedidoPor = (cedula) => {
    setCopiaTituloEspecialidadExpedidoPor(cedula.target.value.toString())
};

const onCopiaTituloSubEspecialidadExpedidoChange = e => {
    setCopiaTituloSubEspecialidadDay(e.target.value)
  };

  const onCopiaTituloSubEspecialidadExpiraChange = e => {
    setCopiaTituloSubEspecialidadExpiraDay(e.target.value)
  };

  const onChangeCopiaTituloSubEspecialidadExpedidoPor = (cedula) => {
    setCopiaTituloSubEspecialidadExpedidoPor(cedula.target.value.toString())
};

const onCopiaTituloSubespecialidadExpedidoChange = e => {
    setCopiaTituloSubespecialidadDay(e.target.value)
  };

  const onCopiaTituloSubespecialidadExpiraChange = e => {
    setCopiaTituloSubespecialidadExpiraDay(e.target.value)
  };

  const onChangeCopiaTituloSubespecialidadExpedidoPor = (cedula) => {
    setCopiaTituloSubespecialidadExpedidoPor(cedula.target.value.toString())
};

const onCertificacionConsejoEspecialidadExpedidoChange = e => {
    setCertificacionConsejoEspecialidadDay(e.target.value)
  };

  const onCertificacionConsejoEspecialidadExpiraChange = e => {
    setCertificacionConsejoEspecialidadExpiraDay(e.target.value)
  };

  const onCertificacionConsejoEspecialidadExpedidoPor = (cedula) => {
    setCertificacionConsejoEspecialidadExpedidoPor(cedula.target.value.toString())
};

const onAvisoFuncionamientoExpedidoChange = e => {
    setAvisoFuncionamientoDay(e.target.value)
  };

  const onAvisoFuncionamientoExpiraChange = e => {
    setAvisoFuncionamientoExpiraDay(e.target.value)
  };

  const onAvisoFuncionamientoExpedidoPor = (cedula) => {
    setAvisoFuncionamientoExpedidoPor(cedula.target.value.toString())
};

const onRegistroEstatalProfesionalesExpedidoChange = e => {
    setRegistroEstatalProfesionalesDay(e.target.value)
  };

  const onRegistroEstatalProfesionalesExpiraChange = e => {
    setRegistroEstatalProfesionalesExpiraDay(e.target.value)
  };

  const onRegistroEstatalProfesionalesExpedidoPor = (cedula) => {
    setRegistroEstatalProfesionalesExpedidoPor(cedula.target.value.toString())
};

    return(
        <section className='seccion_pacientes_pendientes' key={identificadorUnico}>
            <div id="cuerpoEncabezado" className='cuerpoEncabezado'>
                <button className="btn-flotante" title="Agregar credencial" alt="Agregar" onClick={handleAgregar()}>X Regresar</button>
                <EncabezadoSeccion tituloInicial={"Nuevo "} tituloFinal={"Asociado"} imgSource={"https://hospitalesmac.com/img/icono_16.png"} cantidad={cantidadPacientes}/>
            </div>
            <div className='cuerpoPacientes'>
                <div className="reserve_form">
                <p className="reserve_title">{identificadorUnico}</p>
                    <div className={nombreHadError ? "contenedorError":"contenedor"} id="contenedorNombre">
                            <div className="contenedorEncabezado">
                                Nombre del Asociado<span className="requerido">*</span>
                            </div>
                            <input 
                                type={"text"} 
                                id="nombre" 
                                name="nombre" 
                                className="datos"
                                value={nombre}
                                onChange={onChangeNombre}/>
                    </div>
                    <div className={nombreHadError ? "contenedorError":"contenedor"} id="contenedorNombre">
                            <div className="contenedorEncabezado">
                                Apellido del Asociado<span className="requerido">*</span>
                            </div>
                            <input 
                                type={"text"} 
                                id="apellido" 
                                name="apellido" 
                                className="datos"
                                value={apellido}
                                onChange={onChangeApellido}/>
                    </div>
                    {/* <div className="contenedor" id="contenedorSexo">
                        <div className="contenedorEncabezado">
                            Sexo
                        </div>
                        <div onChange={onChangeSexo} className="datos">
                            <input type="radio" value="1" name="genderSexo" /> Hombre
                            <input type="radio" value="0" name="genderSexo" /> Murjer
                        </div>
                    </div> */}
                    <div className={curpHadError ? "contenedorError":"contenedor"} id="contenedorCurp">
                            <div className="contenedorEncabezado">
                                CURP del Asociado<span className="requerido">*</span>
                            </div>
                            <input 
                                type={"text"} 
                                id="curp" 
                                name="curp" 
                                className="datos"
                                value={curp}
                                onChange={onChangeCurp}/>
                    </div>
                    <div className={nombreHadError ? "contenedorError":"contenedor"} id="contenedorEspecialidad">
                            <div className="contenedorEncabezado">
                                Especialidad<span className="requerido">*</span>
                            </div>
                            <input 
                                type={"text"} 
                                id="especialidad" 
                                name="especialidad" 
                                className="datos"
                                value={especialidad}
                                onChange={onChangeEspecialidad}/>
                            <div className="contenedorEncabezado">
                                Cédula Especialidad<span className="requerido">*</span>
                            </div>
                            <input 
                                type={"text"} 
                                id="cedulaespecialidad" 
                                name="cedulaespecialidad" 
                                className="datos"
                                value={cedula}
                                onChange={onChangeCedulaEspecialidad}/>
                            <p className='boton_uno' id='enviar' onClick={handleAgregarEspecialidadClick()}>Agregar Especialidad</p>
                            <h3 className='datos'>{especialidades}</h3>
                    </div>
                    <div className={nombreHadError ? "contenedorError":"contenedor"} id="contenedorSubEspecialidad">
                            <div className="contenedorEncabezado">
                                SubEspecialidad<span className="requerido">*</span>
                            </div>
                            <input 
                                type={"text"} 
                                id="subespecialidad" 
                                name="subespecialidad" 
                                className="datos"
                                value={subespecialidad}
                                onChange={onChangeSubEspecialidad}/>
                    </div>
                    <div className="contenedor" id="contenedorHospital">
                        <div className="contenedorEncabezado">
                            Unidad Hospitalaria
                        </div>
                        {
                            isAdmin
                                ?
                                    <select onChange={(e) => handleChange(e)}> 
                                        {
                                            uhList.map(uh =>
                                                <option value={uh.hospital}>{uh.hospital}</option>
                                            )
                                        }
                                    </select>
                                :
                                    <select onChange={(e) => handleChange(e)}> 
                                        <option value={uhSelected}>{uhSelected}</option>
                                    </select>
                        }
                        
                    </div>
                    <div className="contenedor" id="contenedorFotografia">
                        <div className="contenedorEncabezado">
                            Fotografía
                        </div>
                        <div onChange={onChangeFotografia} className="datos">
                            <input type="radio" value="1" name="gender7" /> Entregado
                            <input type="radio" value="0" name="gender7" /> Pendiente
                        </div>
                        {
                            mostrarSelectorImagenFotografia
                                ?
                                    <>
                                        <label htmlFor="files7" className="input">Seleccione la Fotografía del asociado</label>
                                        <input type="file" id="files7" className='file' onChange={(input)=> {
                                            let file = input.target.files[0];
                                            setFileFotografia(file)

                                            let reader = new FileReader();
                                            reducir()
                                            async function reducir(){
                                                const image = await resizeFile(file);
                                                setBaseFotografia(image)
                                            }

                                            //reader.readAsText(file);
                                            reader.readAsDataURL(file);
                                            reader.onload = function() {
                                                //setBaseFotografia(reader.result)
                                            };

                                            reader.onerror = function() {
                                                //console.log(reader.error);
                                            };


                                        }} accept='.png'/>
                                    </>
                                :
                                    null
                        }
                    </div>

                    <div className="contenedor" id="contenedorIne">
                        <div className="contenedorEncabezado">
                            INE (Ambos lados)
                        </div>
                        <div onChange={onChangeIne} className="datos">
                            <input type="radio" value="1" name="gender8" /> Entregado
                            <input type="radio" value="0" name="gender8" /> Pendiente
                        </div>
                        {
                            mostrarSelectorImagenIne
                                ?
                                    <>
                                        <label htmlFor="files8" className="input">Seleccione la Copia del INE del asociado</label>
                                        <input type="file" id="files8" className='file' onChange={(input)=> {
                                            let file = input.target.files[0];
                                            setFileIne(file)

                                            let reader = new FileReader();

                                            //reader.readAsText(file);
                                            reader.readAsDataURL(file);
                                            reader.onload = function() {
                                                setBaseIne(reader.result)
                                            };

                                        }} accept='image/*,.pdf'/>
                                    </>
                                :
                                    null
                        }
                    </div>

                    <div className="contenedor" id="contenedorRfc">
                        <div className="contenedorEncabezado">
                            RFC (Constancia de Situación Fiscal)
                        </div>
                        <div onChange={onChangeRfc} className="datos">
                            <input type="radio" value="1" name="gender9" /> Entregado
                            <input type="radio" value="0" name="gender9" /> Pendiente
                        </div>
                        {
                            mostrarSelectorImagenRfc
                                ?
                                    <>
                                        <label htmlFor="files9" className="input">Seleccione la Copia del RFC del asociado</label>
                                        <input type="file" id="files9" className='file' onChange={(input)=> {
                                            let file = input.target.files[0];
                                            setFileRfc(file)

                                            let reader = new FileReader();

                                            //reader.readAsText(file);
                                            reader.readAsDataURL(file);
                                            reader.onload = function() {
                                                setBaseRfc(reader.result)
                                            };

                                        }} accept='image/*,.pdf'/>
                                    </>
                                :
                                    null
                        }
                    </div>

                    <div className="contenedor" id="contenedorCopiTituloProfesional">
                        <div className="contenedorEncabezado">
                            Copia título profesional
                        </div>
                        <div onChange={onChangeCopiaTituloProfesional} className="datos">
                            <input type="radio" value="1" name="gender1" /> Entregado
                            <input type="radio" value="0" name="gender1" /> Pendiente
                        </div>
                        {
                            mostrarSelectorImagenCopiaTituloProfesional
                                ?
                                    <>
                                        <label htmlFor="files1" className="input">Seleccione la Copia título profesional</label>
                                        <input type="file" id="files1" className='file' onChange={(input)=> {
                                            let file = input.target.files[0];
                                            setFileCopiaTituloProfesional(file)
                                            let reader = new FileReader();

                                            //reader.readAsText(file);
                                            reader.readAsDataURL(file);
                                            reader.onload = function() {
                                                setBase_copy_professional_title(reader.result)
                                            };

                                        }} accept='image/*,.pdf'/>
                                        <br/>
                                        <label className="input">Fecha de expedición del documento </label>
                                        <input
                                            type="date"
                                            onChange={onCopitaTitutloProfesionalExpedidoChange}
                                            value={copiaTituloProfesionalDay}
                                            max={today}
                                        />
                                        <br/>
                                        <label className="input">Expedido por </label>
                                        <input 
                                            type={"text"} 
                                            id="tituloProfesionalExpedidoPor" 
                                            name="tituloProfesionalExpedidoPor" 
                                            className="datos"
                                            value={tituloProfesionalExpedidoPor}
                                            onChange={onChangeTituloProfesionalExpedidoPor}/>
                                        <br/>
                                        <label className="input">Fecha de expiración del documento </label>
                                        <input
                                            type="date"
                                            onChange={onCopitaTitutloProfesionalExpiraChange}
                                            value={copiaTituloProfesionalExpiraDay}
                                        />
                                    </>
                                :
                                    null
                        }
                    </div>

                    <div className="contenedor" id="contenedorCopiaCedulaProfesional">
                        <div className="contenedorEncabezado">
                        Copia cédula profesional
                        </div>
                        <div onChange={onChangeCopiaCedulaProfesional} className="datos">
                            <input type="radio" value="1" name="gender2" /> Entregado
                            <input type="radio" value="0" name="gender2" /> Pendiente
                        </div>
                        {
                            mostrarSelectorImagenCopiaCedulaProfesional
                                ?
                                    <>
                                        <label htmlFor="files2" className="input">Seleccione la Copia cédula profesional</label>
                                        <input type="file" id="files2" className='file' onChange={(input)=> {
                                            let file = input.target.files[0];
                                            setFileCopiaCedulaProfesional(file)
                                            let reader = new FileReader();

                                            //reader.readAsText(file);
                                            reader.readAsDataURL(file);
                                            reader.onload = function() {
                                                setBase_copy_professional_license(reader.result)
                                            };
                                        }} accept='image/*,.pdf'/>
                                        <br/>
                                        <label className="input">Fecha de expedición del documento </label>
                                        <input
                                            type="date"
                                            onChange={onCopiaCedulaProfesionalExpedidoChange}
                                            value={copiaCedulaProfesionalDay}
                                            max={today}
                                        />
                                        <br/>
                                        <label className="input">Expedido por </label>
                                        <input 
                                            type={"text"} 
                                            id="CedulaProfesionalExpedidoPor" 
                                            name="CedulaProfesionalExpedidoPor" 
                                            className="datos"
                                            value={CedulaProfesionalExpedidoPor}
                                            onChange={onChangeCedulaProfesionalExpedidoPor}/>
                                        <br/>
                                        <label className="input">Fecha de expiración del documento </label>
                                        <input
                                            type="date"
                                            onChange={onCopiaCedulaProfesionalExpiraChange}
                                            value={copiaCedulaProfesionalExpiraDay}
                                        />
                                    </>
                                :
                                    null
                        }
                    </div>

                    <div className="contenedor" id="contenedorCopiaCedulaEspecialidad">
                        <div className="contenedorEncabezado">
                        Copia cédula especialidad
                        </div>
                        <div onChange={onChangeCopiaCedulaEspecialidad} className="datos">
                            <input type="radio" value="1" name="gender3" /> Entregado
                            <input type="radio" value="0" name="gender3" /> Pendiente
                        </div>
                        {
                            mostrarSelectorImagenCopiaCedulaEspecialidad
                                ?
                                    <>
                                        <label htmlFor="files3" className="input">Seleccione la Copia cédula especialidad</label>
                                        <input type="file" id="files3" className='file' onChange={(input)=> {
                                            let file = input.target.files[0];
                                            setFileCopiaCedulaEspecialidad(file)
                                            let reader = new FileReader();

                                            //reader.readAsText(file);
                                            reader.readAsDataURL(file);
                                            reader.onload = function() {
                                                setBase_copy_specialty_certificate(reader.result)
                                            };

                                        }} accept='image/*,.pdf'/>
                                        <br/>
                                        <label className="input">Fecha de expedición del documento </label>
                                        <input
                                            type="date"
                                            onChange={onCopiaCedulaEspecialidadExpedidoChange}
                                            value={copiaCedulaEspecialidadDay}
                                            max={today}
                                        />
                                        <br/>
                                        <label className="input">Expedido por </label>
                                        <input 
                                            type={"text"} 
                                            id="CedulaEspecialidadExpedidoPor" 
                                            name="CedulaEspecialidadExpedidoPor" 
                                            className="datos"
                                            value={CedulaEspecialidadExpedidoPor}
                                            onChange={onChangeCedulaEspecialidadExpedidoPor}/>
                                        <br/>
                                        <label className="input">Fecha de expiración del documento </label>
                                        <input
                                            type="date"
                                            onChange={onCopiaCedulaEspecialidadExpiraChange}
                                            value={copiaCedulaEspecialidadExpiraDay}
                                        />
                                    </>
                                :
                                    null
                        }
                    </div>

                    <div className="contenedor" id="contenedorCopiaTituloEspecialidad">
                        <div className="contenedorEncabezado">
                        Copia título especialidad
                        </div>
                        <div onChange={onChangeCopiaTituloEspecialidad} className="datos">
                            <input type="radio" value="1" name="gender4" /> Entregado
                            <input type="radio" value="0" name="gender4" /> Pendiente
                        </div>
                        {
                            mostrarSelectorImagenCopiaTituloEspecialidad
                                ?
                                    <>
                                        <label htmlFor="files4" className="input">Seleccione la Copia título especialidad</label>
                                        <input type="file" id="files4" className='file' onChange={(input)=> {
                                            let file = input.target.files[0];
                                            setFileCopiaTituloEspecialidad(file)
                                            let reader = new FileReader();

                                            //reader.readAsText(file);
                                            reader.readAsDataURL(file);
                                            reader.onload = function() {
                                                setBase_copy_specialty_title(reader.result)
                                            };
                                        }} accept='image/*,.pdf'/>
                                        <br/>
                                        <label className="input">Fecha de expedición del documento </label>
                                        <input
                                            type="date"
                                            onChange={onCopiaTituloEspecialidadExpedidoChange}
                                            value={copiaTituloEspecialidadDay}
                                            max={today}
                                        />
                                        <br/>
                                        <label className="input">Expedido por </label>
                                        <input 
                                            type={"text"} 
                                            id="copiaTituloEspecialidadExpedidoPor" 
                                            name="copiaTituloEspecialidadExpedidoPor" 
                                            className="datos"
                                            value={copiaTituloEspecialidadExpedidoPor}
                                            onChange={onChangeCopiaTituloEspecialidadExpedidoPor}/>
                                        <br/>
                                        <label className="input">Fecha de expiración del documento </label>
                                        <input
                                            type="date"
                                            onChange={onCopiaTituloEspecialidadExpiraChange}
                                            value={copiaTituloEspecialidadExpiraDay}
                                        />
                                    </>
                                :
                                    null
                        }
                    </div>

                    <div className="contenedor" id="contenedorCopiaCedulaSubEspecialidad">
                        <div className="contenedorEncabezado">
                            Copia de la Cédula Profesional de Sub especialidad
                        </div>
                        <div onChange={onChangeCedulaSubEspecialidad} className="datos">
                            <input type="radio" value="1" name="gender12" /> Entregado
                            <input type="radio" value="0" name="gender12" /> Pendiente
                        </div>
                        {
                            mostrarSelectorImagenCedulaSubEspecialidad
                                ?
                                    <>
                                        <label htmlFor="files12" className="input">Seleccione la Copia de la Cédula Profesional de Sub especialidad</label>
                                        <input type="file" id="files12" className='file' onChange={(input)=> {
                                            let file = input.target.files[0];
                                            setFileCedulaSubEspecialidad(file)
                                            let reader = new FileReader();

                                            //reader.readAsText(file);
                                            reader.readAsDataURL(file);
                                            reader.onload = function() {
                                                setBase_copy_subspecialty_professional_certificate(reader.result)
                                            };
                                        }} accept='image/*,.pdf'/>
                                        <br/>
                                        <label className="input">Fecha de expedición del documento </label>
                                        <input
                                            type="date"
                                            onChange={onCopiaTituloSubEspecialidadExpedidoChange}
                                            value={copiaTituloSubEspecialidadDay}
                                            max={today}
                                        />
                                        <br/>
                                        <label className="input">Expedido por </label>
                                        <input 
                                            type={"text"} 
                                            id="copiaTituloSubEspecialidadExpedidoPor" 
                                            name="copiaTituloSubEspecialidadExpedidoPor" 
                                            className="datos"
                                            value={copiaTituloSubEspecialidadExpedidoPor}
                                            onChange={onChangeCopiaTituloSubEspecialidadExpedidoPor}/>
                                        <br/>
                                        <label className="input">Fecha de expiración del documento </label>
                                        <input
                                            type="date"
                                            onChange={onCopiaTituloSubEspecialidadExpiraChange}
                                            value={copiaTituloSubEspecialidadExpiraDay}
                                        />
                                    </>
                                :
                                    null
                        }
                    </div>

                    <div className="contenedor" id="contenedorCopiaTituloSubEspecialidad">
                        <div className="contenedorEncabezado">
                        Copia título subespecialidad
                        </div>
                        <div onChange={onChangeCopiaTituloSubEspecialidad} className="datos">
                            <input type="radio" value="1" name="gender5" /> Entregado
                            <input type="radio" value="0" name="gender5" /> Pendiente
                        </div>
                        {
                            mostrarSelectorImagenCopiaTituloSubEspecialidad
                                ?
                                    <>
                                        <label htmlFor="files5" className="input">Seleccione la Copia título subespecialidad</label>
                                        <input type="file" id="files5" className='file' onChange={(input)=> {
                                            let file = input.target.files[0];
                                            setFileCopiaTituloSubEspecialidad(file)
                                            let reader = new FileReader();

                                            //reader.readAsText(file);
                                            reader.readAsDataURL(file);
                                            reader.onload = function() {
                                                setBase_copy_subspecial_title(reader.result)
                                            };

                                        }} accept='image/*,.pdf'/>
                                        <br/>
                                        <label className="input">Fecha de expedición del documento </label>
                                        <input
                                            type="date"
                                            onChange={onCopiaTituloSubespecialidadExpedidoChange}
                                            value={copiaTituloSubespecialidadDay}
                                            max={today}
                                        />
                                        <br/>
                                        <label className="input">Expedido por </label>
                                        <input 
                                            type={"text"} 
                                            id="copiaTituloSubespecialidadExpedidoPor" 
                                            name="copiaTituloSubespecialidadExpedidoPor" 
                                            className="datos"
                                            value={copiaTituloSubespecialidadExpedidoPor}
                                            onChange={onChangeCopiaTituloSubespecialidadExpedidoPor}/>
                                        <br/>
                                        <label className="input">Fecha de expiración del documento </label>
                                        <input
                                            type="date"
                                            onChange={onCopiaTituloSubespecialidadExpiraChange}
                                            value={copiaTituloSubespecialidadExpiraDay}
                                        />
                                    </>
                                :
                                    null
                        }
                    </div>

                    <div className="contenedor" id="contenedorCopiaCertificadoConsejoEspecialidad">
                        <div className="contenedorEncabezado">
                            Copia Certificación de consejo de especialidad de ambos lados vigente
                        </div>
                        <div onChange={onChangeCertificadoConsejoEspecialidad} className="datos">
                            <input type="radio" value="1" name="gender13" /> Entregado
                            <input type="radio" value="0" name="gender13" /> Pendiente
                        </div>
                        {
                            mostrarSelectorImagenCertificacionConsejoEspecialidad
                                ?
                                    <>
                                        <label htmlFor="files13" className="input">Seleccione la Copia Certificación de consejo de especialidad de ambos lados vigente</label>
                                        <input type="file" id="files13" className='file' onChange={(input)=> {
                                            let file = input.target.files[0];
                                            setFileCertificacionConsejoEspecialidad(file)
                                            let reader = new FileReader();

                                            //reader.readAsText(file);
                                            reader.readAsDataURL(file);
                                            reader.onload = function() {
                                                setBase_copy_specialty_board_certification(reader.result)
                                            };
                                        }} accept='image/*,.pdf'/>
                                        <br/>
                                        <label className="input">Fecha de expedición del documento </label>
                                        <input
                                            type="date"
                                            onChange={onCertificacionConsejoEspecialidadExpedidoChange}
                                            value={certificacionConsejoEspecialidadDay}
                                            max={today}
                                        />
                                        <br/>
                                        <label className="input">Expedido por </label>
                                        <input 
                                            type={"text"} 
                                            id="certificacionConsejoEspecialidadExpedidoPor" 
                                            name="certificacionConsejoEspecialidadExpedidoPor" 
                                            className="datos"
                                            value={certificacionConsejoEspecialidadExpedidoPor}
                                            onChange={onCertificacionConsejoEspecialidadExpedidoPor}/>
                                        <br/>
                                        <label className="input">Fecha de expiración del documento </label>
                                        <input
                                            type="date"
                                            onChange={onCertificacionConsejoEspecialidadExpiraChange}
                                            value={certificacionConsejoEspecialidadExpiraDay}
                                        />
                                    </>
                                :
                                    null
                        }
                    </div>

                    <div className="contenedor" id="contenedorAvisoFuncionamiento">
                        <div className="contenedorEncabezado">
                            Copia del Aviso de funcionamiento de consultorio
                        </div>
                        <div onChange={onChangeAvisoFuncionamiento} className="datos">
                            <input type="radio" value="1" name="gender10" /> Entregado
                            <input type="radio" value="0" name="gender10" /> Pendiente
                        </div>
                        {
                            mostrarSelectorImagenAvisoFuncionamiento
                                ?
                                    <>
                                        <label htmlFor="files10" className="input">Seleccione la Copia del Aviso de funcionamiento de consultorio</label>
                                        <input type="file" id="files10" className='file' onChange={(input)=> {
                                            let file = input.target.files[0];
                                            setFileAvisoFuncionamiento(file)
                                            let reader = new FileReader();

                                            //reader.readAsText(file);
                                            reader.readAsDataURL(file);
                                            reader.onload = function() {
                                                setbBase_copy_of_office_operating_notice(reader.result)
                                            };

                                        }} accept='image/*,.pdf'/>
                                        <br/>
                                        <label className="input">Fecha de expedición del documento </label>
                                        <input
                                            type="date"
                                            onChange={onAvisoFuncionamientoExpedidoChange}
                                            value={avisoFuncionamientoDay}
                                            max={today}
                                        />
                                        <br/>
                                        <label className="input">Expedido por </label>
                                        <input 
                                            type={"text"} 
                                            id="avisoFuncionamientoExpedidoPor" 
                                            name="avisoFuncionamientoExpedidoPor" 
                                            className="datos"
                                            value={avisoFuncionamientoExpedidoPor}
                                            onChange={onAvisoFuncionamientoExpedidoPor}/>
                                        <br/>
                                        <label className="input">Fecha de expiración del documento </label>
                                        <input
                                            type="date"
                                            onChange={onAvisoFuncionamientoExpiraChange}
                                            value={avisoFuncionamientoExpiraDay}
                                        />
                                    </>
                                :
                                    null
                        }
                    </div>

                    <div className="contenedor" id="contenedorRegistroEstatalProfesional">
                        <div className="contenedorEncabezado">
                            Copia del Registro Estatal de Profesiones
                        </div>
                        <div onChange={onChangeRegistroEstatalProfesionales} className="datos">
                            <input type="radio" value="1" name="gender11" /> Entregado
                            <input type="radio" value="0" name="gender11" /> Pendiente
                        </div>
                        {
                            mostrarSelectorImagenRegistroEstatalProfesionales
                                ?
                                    <>
                                        <label htmlFor="files11" className="input">Seleccione la Copia del Registro Estatal de Profesiones</label>
                                        <input type="file" id="files11" className='file' onChange={(input)=> {
                                            let file = input.target.files[0];
                                            setFileRegistroEstatalProfesionales(file)
                                            let reader = new FileReader();

                                            //reader.readAsText(file);
                                            reader.readAsDataURL(file);
                                            reader.onload = function() {
                                                setBase_copy_state_registry_of_professions(reader.result)
                                            };
                                        }} accept='image/*,.pdf'/>
                                        <br/>
                                        <label className="input">Fecha de expedición del documento </label>
                                        <input
                                            type="date"
                                            onChange={onRegistroEstatalProfesionalesExpedidoChange}
                                            value={registroEstatalProfesionalesDay}
                                            max={today}
                                        />
                                        <br/>
                                        <label className="input">Expedido por </label>
                                        <input 
                                            type={"text"} 
                                            id="registroEstatalProfesionalesExpedidoPor" 
                                            name="registroEstatalProfesionalesExpedidoPor" 
                                            className="datos"
                                            value={registroEstatalProfesionalesExpedidoPor}
                                            onChange={onRegistroEstatalProfesionalesExpedidoPor}/>
                                        <br/>
                                        <label className="input">Fecha de expiración del documento </label>
                                        <input
                                            type="date"
                                            onChange={onRegistroEstatalProfesionalesExpiraChange}
                                            value={registroEstatalProfesionalesExpiraDay}
                                        />
                                    </>
                                :
                                    null
                        }
                    </div>

                    <div className="contenedor" id="contenedorCv">
                        <div className="contenedorEncabezado">
                        Currículum Vitae
                        </div>
                        <div onChange={onChangeCv} className="datos">
                            <input type="radio" value="1" name="gender6" /> Entregado
                            <input type="radio" value="0" name="gender6" /> Pendiente
                        </div>
                        {
                            mostrarSelectorImagenCv
                                ?
                                    <>
                                        <label htmlFor="files6" className="input">Seleccione el Currículum Vitae</label>
                                        <input type="file" id="files6" className='file' onChange={(input)=> {
                                            let file = input.target.files[0];
                                            setFileCv(file)
                                            let reader = new FileReader();

                                            //reader.readAsText(file);
                                            reader.readAsDataURL(file);
                                            reader.onload = function() {
                                                setBaseCv(reader.result)
                                            };
                                        }} accept='image/*,.pdf'/>
                                    </>
                                :
                                    null
                        }
                    </div>

                    <div className="contenedor" id="contenedorConstancias">
                        <div className="contenedorEncabezado">
                            Constancias de cursos o congresos de los últimos 5 años (una constancia por año).
                        </div>
                        <h1 className='info_itemblog'>{constanciaUnoName}</h1>
                        <div onChange={onChangeConstanciaUno} className="datos">
                            <input type="radio" value="1" name="gender14" /> Entregado
                            <input type="radio" value="0" name="gender14" /> Pendiente
                        </div>
                        {
                            mostrarSelectorImagenConstanciaUno
                                ?
                                    <>
                                        <label htmlFor="files14" className="input">Seleccione la Constancia del año {constanciaUnoName}</label>
                                        <input type="file" id="files14" className='file' onChange={(input)=> {
                                            let file = input.target.files[0];
                                            setFileConstanciaUno(file)
                                        }} accept='image/*,.pdf'/>
                                    </>
                                :
                                    null
                        }
                        <h1 className='info_itemblog'>{constanciaDosName}</h1>
                        <div onChange={onChangeConstanciaDos} className="datos">
                            <input type="radio" value="1" name="gender15" /> Entregado
                            <input type="radio" value="0" name="gender15" /> Pendiente
                        </div>
                        {
                            mostrarSelectorImagenConstanciaDos
                                ?
                                    <>
                                        <label htmlFor="files15" className="input">Seleccione la Constancia del año {constanciaDosName}</label>
                                        <input type="file" id="files15" className='file' onChange={(input)=> {
                                            let file = input.target.files[0];
                                            setFileConstanciaDos(file)
                                        }} accept='image/*,.pdf'/>
                                    </>
                                :
                                    null
                        }
                        <h1 className='info_itemblog'>{constanciaTresName}</h1>
                        <div onChange={onChangeConstanciaTres} className="datos">
                            <input type="radio" value="1" name="gender16" /> Entregado
                            <input type="radio" value="0" name="gender16" /> Pendiente
                        </div>
                        {
                            mostrarSelectorImagenConstanciaTres
                                ?
                                    <>
                                        <label htmlFor="files16" className="input">Seleccione la Constancia del año {constanciaTresName}</label>
                                        <input type="file" id="files16" className='file' onChange={(input)=> {
                                            let file = input.target.files[0];
                                            setFileConstanciaTres(file)
                                        }} accept='image/*,.pdf'/>
                                    </>
                                :
                                    null
                        }
                        <h1 className='info_itemblog'>{constanciaCuatroName}</h1>
                        <div onChange={onChangeConstanciaCuatro} className="datos">
                            <input type="radio" value="1" name="gender17" /> Entregado
                            <input type="radio" value="0" name="gender17" /> Pendiente
                        </div>
                        {
                            mostrarSelectorImagenConstanciaCuatro
                                ?
                                    <>
                                        <label htmlFor="files17" className="input">Seleccione la Constancia del año {constanciaCuatroName}</label>
                                        <input type="file" id="files17" className='file' onChange={(input)=> {
                                            let file = input.target.files[0];
                                            setFileConstanciaCuatro(file)
                                        }} accept='image/*,.pdf'/>
                                    </>
                                :
                                    null
                        }
                        <h1 className='info_itemblog'>{constanciaCincoName}</h1>
                        <div onChange={onChangeConstanciaCinco} className="datos">
                            <input type="radio" value="1" name="gender18" /> Entregado
                            <input type="radio" value="0" name="gender18" /> Pendiente
                        </div>
                        {
                            mostrarSelectorImagenConstanciaCinco
                                ?
                                    <>
                                        <label htmlFor="files18" className="input">Seleccione la Constancia del año {constanciaCincoName}</label>
                                        <input type="file" id="files18" className='file' onChange={(input)=> {
                                            let file = input.target.files[0];
                                            setFileConstanciaCinco(file)
                                        }} accept='image/*,.pdf'/>
                                    </>
                                :
                                    null
                        }
                    </div>

                </div>
                <p className='boton_uno' id='enviar' onClick={handleGuardar()}>Guardar</p>
            </div>
        </section>
    )
}

export default AsociadoForm